import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductFamily, ProductFamilyState } from './types';

const initialState: ProductFamilyState = {
  productFamilyList: [],
  loading: false,
  error: null,
  reset: false
};

const productFamilySlice = createSlice({
  name: 'productFamily',
  initialState,
  reducers: {
    setProductFamilyList: (state, action: PayloadAction<ProductFamily[]>) => {
      state.productFamilyList = action.payload;
      state.loading = false;
      state.error = null;
      state.reset = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    reset: (state) => {
      state.reset = true;
    },
    clearReset: (state) => {
      state.reset = false;
    }
  }
});

export const {
  setProductFamilyList,
  setLoading,
  setError,
  reset,
  clearReset
} = productFamilySlice.actions;

export default productFamilySlice.reducer;